import {Text} from "@unibuddy/patron";
import {useAnalytics} from "@unibuddy/tracking";
import {TrackEvents, UniversityFeatureFlags} from "ubcommunity-shared/src/constants";
import {AutocompleteModal} from "ubcommunity-shared/src/General/AutocompleteModal/AutocompleteModal";
import {useUniversityFeature} from "ubcommunity-shared/src/Hooks/useUniversityFeature";
import {useAllDegreeLevelsQuery} from "ubcommunity-shared/src/types";

interface IEditDegreeLevelProps {
    universitySlug: string;
}

const EditDegreeLevel = ({universitySlug}: IEditDegreeLevelProps) => {
    const {isFeatureEnabled} = useUniversityFeature(universitySlug);
    const isDegreeLevelEnabled = isFeatureEnabled(UniversityFeatureFlags.CUSTOM_LEVELS_ENABLED);
    const {trackEvent} = useAnalytics();
    const {data, loading, error} = useAllDegreeLevelsQuery({
        variables: {universitySlug},
        skip: !isDegreeLevelEnabled,
    });

    if (!isDegreeLevelEnabled || loading || error || data?.allDegreeLevels?.length === 0) {
        return null;
    }

    const handleOnDialogOpened = () => {
        trackEvent(TrackEvents.SELECT_DOMESTIC_REGION_OPEN);
    };

    const handleOnDialogDismiss = () => {
        trackEvent(TrackEvents.SELECT_DOMESTIC_REGION_DISMISSED);
    };

    return (
        <AutocompleteModal
            name="selectDegreeLevel"
            label="What degree level are you interested in?"
            data={data?.allDegreeLevels}
            renderItem={(item) => <Text>{item.name}</Text>}
            resultKey="name"
            onDropdownOpened={handleOnDialogOpened}
            onDismiss={handleOnDialogDismiss}
            placeholder="Select level"
            required
        />
    );
};

export default EditDegreeLevel;
